import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, Output, EventEmitter, Input, signal } from '@angular/core';
import { Card } from './interfaces/list-cards-user.interface';
import { AddNewCardComponent } from '../add-new-card/add-new-card.component';
import { DeleteCardModalComponent } from '../delete-card-modal/delete-card-modal.component';

import { Subscription } from 'rxjs';
import { CardsStateService } from '../../services/cards-state.service';


interface CardSelectionEvent {
  card: Card;
  cvv: string;
}

@Component({
  selector: 'mercado-pago-list-cards-user',
  standalone: true,
  imports: [CommonModule, AddNewCardComponent, DeleteCardModalComponent],
  templateUrl: './list-cards-user.component.html',
  styleUrl: './list-cards-user.component.css'
})
export class ListCardsUserComponent implements OnInit {
  cards: Card[] | null = null;
  isLoading=signal( false);
  hasError: boolean = false;
  showDeleteModal: boolean = false;
  selectedCard: Card | null = null;
  selectedPaymentCard: Card | null = null;
  showCvvModal: boolean = false;
  isLoadingAddCard: boolean = false;
  @ViewChild(AddNewCardComponent) addNewCardComponent!: AddNewCardComponent;
  @Input() showButton: boolean = true;
  @Output() cardSelected = new EventEmitter<CardSelectionEvent>();
  private subscriptions: Subscription = new Subscription();

  constructor(
    private cardsStateService: CardsStateService
  ) {
  }

  ngOnInit(): void {
    // Load cards initially
    this.loadUserCards();

    // El effect ya maneja toda la lógica de mostrar/ocultar cards
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  loadUserCards(): void {
    this.isLoading.set(true);
    this.hasError = false;
    this.cards = null;

    // Suscribirse al estado de carga
    const loadingSub = this.cardsStateService.loading$.subscribe(loading => {
      this.isLoading.set(loading);
    });
    this.subscriptions.add(loadingSub);

    // Suscribirse al estado de error
    const errorSub = this.cardsStateService.error$.subscribe(error => {
      this.hasError = error;
    });
    this.subscriptions.add(errorSub);

    // Suscribirse a las tarjetas
    const cardsSub = this.cardsStateService.cards$.subscribe(cards => {
      this.cards = cards;
    });
    this.subscriptions.add(cardsSub);

    // Solicitar las tarjetas (solo hará la petición HTTP si es necesario)
    this.cardsStateService.getUserCards();
  }

  openAddCardModal(): void {
    this.isLoadingAddCard = true;
    setTimeout(() => {
      if (this.addNewCardComponent) {
        this.addNewCardComponent.openModal();
        this.isLoadingAddCard = false;
      }
    }, 500);
  }

  openDeleteModal(card: Card): void {
    this.selectedCard = card;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
    this.selectedCard = null;
  }

  onCardDeleted(): void {
    this.cardsStateService.refreshCards();
    this.closeDeleteModal();
  }

  selectCard(card: Card): void {
    this.selectedPaymentCard = card;
    // Notificar al servicio de estado compartido
    this.cardsStateService.selectCard(card);
    // Emitir el evento para el componente padre
    this.cardSelected.emit({
      card: card,
      cvv: ''
    });
  }
}
